import { makeStyles, Button, Grid, IconButton, InputAdornment, Tooltip, Dialog, DialogContent, DialogActions } from '@material-ui/core'
import { OnChange } from 'react-final-form-listeners'
import { TextField, Select, Checkboxes } from 'mui-rff'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { useEffect, useState } from 'react'
import { validationRuleFormValues } from 'utils/rules'
import * as csv from 'papaparse'
import { Build } from '@material-ui/icons'
import { Table as FluidTable } from 'react-fluid-table'
const csvParsePromise = file => new Promise((complete, error) => { csv.parse(file, { complete, error }) })

const useStyles = makeStyles((theme) => ({
  virtualtable: {
    '& .header-cell': {
      textAlign: 'center',
      '& div': {
        width: '100%'
      }
    },
    '& .row-container:hover': {
      backgroundColor: '#fcfcfc'
    }
  },
  tableHeader: {
    fontWeight: '800',
    textAlign: 'center',
    width: '100%'
  },
  buttonBlue: {
    color: theme.palette.getContrastText(theme.palette.info.main),
    backgroundColor: theme.palette.info.main,
    '&:hover': {
      backgroundColor: theme.palette.info.dark,
    }
  },
  required: {
    color: 'red',
    position: 'absolute',
    top: '0px',
    right: '2px'
  }
}))
export default function TableComponent({ component, save, saveFast }) {
  const [editor, setEditor] = useState(<></>)
  const [rc, setRc] = useState({ rows: Object.keys(component.Table || {}).length, cols: (Object.values(component.Table || {}).pop() ?? []).length })
  const rows = Math.max(Math.min((parseInt(component.Rows) || 3), 1000), 1)
  const cols = Math.max(Math.min((parseInt(component.Columns) || 3), 20), 1)

  if (!component.Table) component.Table = {}
  for (let ri = 0; ri < rows; ri++) {
    if (!component.Table[ri]) component.Table[ri] = []
    for (let ci = 0; ci < cols; ci++) {
      if (!component.Table[ri][ci]) component.Table[ri][ci] = {
        Prompt: '',
        AllowBlanks: false,
        ValidationRule: 'Any'
      }
    }

    // delete any additional table cols in this row
    while (component.Table[ri].length > cols) component.Table[ri].pop()

  }

  // delete additional table rows past the max rows
  Object.keys(component.Table).forEach(index => {
    if (index >= rows) delete component.Table[index]
  })

  if (rc.rows != rows || rc.cols != cols) {
    setRc({ rows, cols })
    save(component)
  }

  function savePrompt(ri, ci, newVal) {
    component.Table[ri][ci].Prompt = newVal
    save(component)
    createComponentCopy(component)
  }

  function saveRule(ri, ci, newVal) {
    component.Table[ri][ci].ValidationRule = newVal
    save(component)
    createComponentCopy(component)
  }

  function saveOptional(ri, ci, newVal) {
    component.Table[ri][ci].AllowBlanks = newVal
    save(component)
    createComponentCopy(component)
  }

  let componentCopy

  function createComponentCopy(component) {
    componentCopy = JSON.parse(JSON.stringify(component))
    if (!componentCopy.Table) componentCopy.Table = {}
    componentCopy.TempTable = {}
    Object.values(componentCopy.Table).forEach((row, ri) => {
      componentCopy.TempTable[`row${ri}`] = []
      row.forEach((col, ci) => {
        componentCopy.TempTable[`row${ri}`][ci] = col
      })
    })
  }

  createComponentCopy(component)

  const classes = useStyles()

  const CellEditor = ({ ri, ci }) => {
    const [showRules, setShowRules] = useState(false)

    return <>
      <div style={{ position: 'relative', width: '100%' }}>
        <TextField name={`TempTable.row${ri}.${ci}.Prompt`} variant='outlined' placeholder={'Type: ' + componentCopy?.TempTable?.[`row${ri}`]?.[ci]?.ValidationRule ?? 'Any'} InputProps={{
          endAdornment: <InputAdornment>
            <IconButton
              style={{ padding: '0px 0px 0px 5px' }}
              aria-label="cell settings"
              onClick={() => setShowRules(true)}
            >
              <Tooltip title="Cell Settings and Validation Rules"><Build style={{ fontSize: '1rem' }} /></Tooltip>
            </IconButton>
          </InputAdornment>,
        }} />
        <OnChange name={`TempTable.row${ri}.${ci}.Prompt`}>{val => { savePrompt(ri, ci, val) }}</OnChange>
        {componentCopy.TempTable[`row${ri}`][ci].AllowBlanks ? '' : <span className={classes.required}>*</span>}
      </div>
      {showRules && <Dialog open={showRules} onClose={() => setShowRules(false)}>
        <DialogContent><Grid container spacing={1}>
          <Grid item xs={12}>
            <Select label='Validation Rule' name={`TempTable.row${ri}.${ci}.ValidationRule`} variant='outlined' data={validationRuleFormValues()} />
            <OnChange name={`TempTable.row${ri}.${ci}.ValidationRule`}>{val => { saveRule(ri, ci, val) }}</OnChange>
            <Checkboxes name={`TempTable.row${ri}.${ci}.AllowBlanks`} variant='outlined' data={{ label: 'This Cell is Optional', value: true }} />
            <OnChange name={`TempTable.row${ri}.${ci}.AllowBlanks`}>{val => { saveOptional(ri, ci, val) }}</OnChange>
          </Grid>
        </Grid></DialogContent>
        <DialogActions>
          <Button onClick={() => setShowRules(false)}>Apply to Cell</Button>
          <Button onClick={() => {
            Object.values(component.Table).forEach((row, lri) => {
              row.forEach((col, lci) => {
                if (lci === ci) {
                  saveRule(lri, lci, component.Table[ri][ci].ValidationRule)
                  saveOptional(lri, lci, component.Table[ri][ci].AllowBlanks)
                }
              })
            })
            setShowRules(false)
          }}>Apply to Column</Button>
          <Button onClick={() => {
            Object.values(component.Table).forEach((row, lri) => {
              row.forEach((col, lci) => {
                if (lri === ri) {
                  saveRule(lri, lci, component.Table[ri][ci].ValidationRule)
                  saveOptional(lri, lci, component.Table[ri][ci].AllowBlanks)
                }
              })
            })
            setShowRules(false)
          }}>Apply to Row</Button>
          <Button onClick={() => {
            Object.values(component.Table).forEach((row, lri) => {
              row.forEach((col, lci) => {
                saveRule(lri, lci, component.Table[ri][ci].ValidationRule)
                saveOptional(lri, lci, component.Table[ri][ci].AllowBlanks)
              })
            })
            setShowRules(false)
          }}>Apply to All Cells</Button>
        </DialogActions>
      </Dialog>}
    </>
  }

  CellEditor.propTypes = {
    ri: PropTypes.number.isRequired,
    ci: PropTypes.number.isRequired,
  }

  const VirtualTable = ({ rowArray, colArray }) => {
    const data = rowArray.map((row, ri) => {
      const out = {}
      out['rownum'] = <div style={{ textAlign: 'center', width: '100%' }}>{ri + 1}</div>
      colArray.forEach((col, ci) => out[ci] = <CellEditor ri={ri} ci={ci} key={`${ri}-${ci}`} />)
      return out
    })
    const columns = colArray.map((col, ci) => {
      return {
        key: ci,
        header: `Column ${ci + 1}`
      }
    })
    columns.unshift({
      key: 'rownum',
      header: '',
      width: 50
    })
    return <FluidTable data={data} columns={columns} tableHeight={Math.min(2000, (rowArray.length + 1) * 72)} className={classes.virtualtable} />
  }

  VirtualTable.propTypes = {
    rowArray: PropTypes.array.isRequired,
    colArray: PropTypes.array.isRequired
  }

  useEffect(() => {
    const rowArray = [...Array(rows).keys()]
    const colArray = [...Array(cols).keys()]
    setEditor(<VirtualTable rowArray={rowArray} colArray={colArray} />)
  }, [rows, cols])

  return <>
    <Form
      onSubmit={() => { }}
      subscription={{}}
      initialValues={componentCopy}
      render={() => (<>
        <div className={classes.tableHeader}>Note: Empty cells will be used as client input, filled cells will be non-editable by clients</div>
        {editor}
      </>)}
    />
    <Form
      onSubmit={() => { }}
      initialValues={component}
      render={({ values }) => (<Grid container spacing={1}>
        <Grid item xs={12}>
          <Checkboxes name='Header' variant='outlined' data={{ label: 'First Row as Header', value: true }} />
          <OnChange name='Header'>{() => { saveFast(values) }}</OnChange>
          <Checkboxes name='AddRow' variant='outlined' data={{ label: 'Allow New Rows', value: true }} />
          <OnChange name='AddRow'>{() => { saveFast(values) }}</OnChange>
          <Checkboxes name='CSVUpload' variant='outlined' data={{ label: 'Allow CSV Upload', value: true }} />
          <OnChange name='CSVUpload'>{() => { saveFast(values) }}</OnChange>
          <Checkboxes name='CSVDownload' variant='outlined' data={{ label: 'Allow CSV Download', value: true }} />
          <OnChange name='CSVDownload'>{() => { saveFast(values) }}</OnChange>
        </Grid>
        <Grid item xs={12}>
          <Button variant='contained' className={classes.buttonBlue} onClick={() => {
            const f = document.createElement('input')
            f.style.display = 'none'
            f.type = 'file'
            f.accept = '.csv'
            f.id = 'bulkFileUpload'
            document.body.appendChild(f)
            f.addEventListener('change', async e => {
              for (let file of [...e.target.files]) {
                if (file.name.endsWith('.csv')) {
                  const results = await csvParsePromise(file)
                  console.log(results.data)
                  values.Rows = Math.max(results.data.length, parseInt(values.Rows || 0))
                  values.Columns = Math.max(results.data[0].length, parseInt(values.Columns || 0))
                  results.data.forEach((row, ri) => {
                    row.forEach((col, ci) => {
                      console.log(col)
                      if (!values.Table) values.Table = {}
                      if (!values.Table[ri]) values.Table[ri] = []
                      if (!values.Table[ri][ci]) values.Table[ri][ci] = { Prompt: '', ValidationRule: 'Any', AllowBlanks: false }
                      values.Table[ri][ci].Prompt = col
                    })
                  })
                  saveFast(values)
                }
              }
              document.body.removeChild(f)
            })
            f.dispatchEvent(new MouseEvent('click'))
          }}>Pre-fill Table with CSV</Button>
        </Grid></Grid>)}
    />
  </>

}

TableComponent.propTypes = {
  component: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  saveFast: PropTypes.func.isRequired
}